import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ConsultationForm from './ConsultationForm';

const Hero = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const staggerChildren = {
    animate: {
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  return (
    <div className="relative h-screen">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1558769132-cb1aea458c5e?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')",
        }}
      >
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
          <motion.div 
            className="max-w-3xl"
            variants={staggerChildren}
            initial="initial"
            animate="animate"
          >
            <motion.p 
              variants={fadeInUp}
              className="text-emerald-400 text-lg font-medium mb-4"
            >
              Advance Elegance Studio
            </motion.p>
            <motion.h1 
              variants={fadeInUp}
              className="text-5xl md:text-7xl font-bold mb-6"
            >
              <span className="block">Crafting Timeless</span>
              <span className="block">Fashion Elegance</span>
            </motion.h1>
            <motion.p 
              variants={fadeInUp}
              className="text-xl text-gray-300 mb-8"
            >
              Where artistry meets sophistication. Elevate your style with our bespoke fashion designs.
            </motion.p>
            <motion.div 
              variants={fadeInUp}
              className="flex flex-wrap gap-4"
            >
              <motion.button 
                whileHover={{ scale: 1.05, boxShadow: "0 0 20px rgba(52, 211, 153, 0.3)" }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-3 bg-emerald-400 text-black font-semibold rounded-full hover:bg-emerald-300 transition-colors"
              >
                Explore Our Work
              </motion.button>
              <motion.button 
                whileHover={{ scale: 1.05, boxShadow: "0 0 20px rgba(52, 211, 153, 0.2)" }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsConsultationOpen(true)}
                className="px-8 py-3 border-2 border-emerald-400 text-emerald-400 font-semibold rounded-full hover:bg-emerald-400 hover:text-black transition-colors"
              >
                Book a Consultation
              </motion.button>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Animated Scroll Indicator */}
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.5, duration: 0.5 }}
      >
        <motion.div 
          className="w-6 h-10 border-2 border-emerald-400 rounded-full flex justify-center"
          animate={{ boxShadow: ["0 0 0px rgba(52, 211, 153, 0)", "0 0 20px rgba(52, 211, 153, 0.3)", "0 0 0px rgba(52, 211, 153, 0)"] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <motion.div 
            className="w-1 h-3 bg-emerald-400 rounded-full mt-2"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          />
        </motion.div>
      </motion.div>

      {/* Consultation Form */}
      <ConsultationForm 
        isOpen={isConsultationOpen} 
        onClose={() => setIsConsultationOpen(false)} 
      />
    </div>
  );
};

export default Hero;